"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FetchWithAuth;
function FetchWithAuth(authState) {
  return async function (url, options = {}) {
    const {
      access_token,
      claims
    } = authState;
    const {
      company_id
    } = claims;
    options = {
      ...options,
      headers: {
        ...(options.headers || {}),
        'authorization': `Bearer ${access_token}`,
        'company-id': company_id
      }
    };
    return fetch(url, options);
  };
}
//# sourceMappingURL=fetch-with-auth.js.map